import React from 'react';
import { Stack } from '@mui/material';

import RadioButton from 'components/Common/RadioGroup';
import DateAndTimePicker from 'components/Common/DateAndTimePicker';

interface dataItem {
    value: string;
    label: string;
}

interface BasketPickerProp {
    data: dataItem[];
    date: string | Date;
    setDate: (date: string) => void;
    setType: (value: string) => void;
    defaultValue?: string;
    name: string;
    disableDate?: boolean;
    disableTime?: boolean;
    defaultNull?: boolean;
    type?: string;
    children?: React.ReactElement;
    disableRadio?: boolean;
}

function BasketPickerAndDateItem({
    data,
    date,
    setDate,
    setType,
    name,
    disableDate,
    disableTime,
    defaultNull,
    type,
    children,
    disableRadio,
}: BasketPickerProp) {
    return (
        <Stack width="auto">
            <RadioButton disabled={disableRadio} alignItems="flex-start" data={data} value={type} name={name} setValue={setType} />
            <DateAndTimePicker
                date={date}
                setDateAndTime={setDate}
                disableDate={disableDate}
                disableTime={disableTime}
                defaultNull={defaultNull}
            />
            <div>{children}</div>
        </Stack>
    );
}

export default BasketPickerAndDateItem;
